import React from 'react';
import AuthLayoutFixed from './AuthLayoutFixed';
import ThemeErrorBoundary from '../../theme/ThemeErrorBoundary';
import { StyledComponentsIntegration } from '../../theme/StyledComponentsIntegration';

/**
 * AuthLayoutFixedWrapper
 * 
 * This component wraps the AuthLayoutFixed component with the StyledComponentsIntegration
 * to ensure that styled-components has access to the theme.
 */
const AuthLayoutFixedWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ThemeErrorBoundary>
      <StyledComponentsIntegration>
        <AuthLayoutFixed>
          {children}
        </AuthLayoutFixed>
      </StyledComponentsIntegration>
    </ThemeErrorBoundary>
  );
};

export default AuthLayoutFixedWrapper;